/***************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2020 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ***************************************************************************/
import ExternalHost from '../ExternalHost';

/**
 * Host class with overrides for Photoshop
 */
class PhotoshopHost extends ExternalHost {
  /**
   * Constructor
   * @param {HTMLElement} element - HTML Element in DOM to render app to.
   */
  constructor(element) {
    super(element);

    require('../../styles/photoshopExternal.scss');
  }

  /* eslint-disable class-methods-use-this */
  /**
   * Returns host API object
   * @returns {Object} hostApi
   */
  get mount() {
    return window.cdoHost;
  }

  /**
   * Returns promise for fetching asset metadata
   * @returns {Promise} assetMetadata promise
   */
  fetchAssetMetadata() {
    return this.mount.getAssetMetadata();
  }
  /* eslint-enable class-methods-use-this */

  /**
   * Checks if Photoshop is the host.
   * @param {String} appName - Application name
   * @returns {boolean} - returns boolean if in correct env.
   */
  static check(appName) {
    return appName.toLowerCase() === 'photoshop';
  }
}

export default PhotoshopHost;
